export type ActivityType = "Top Up" | "Payout";
export const ACTIVITY_TOP_UP = "Top Up";
export const ACTIVITY_PAYOUT = "Payout";
